<script setup lang="ts">
// 底部暂时不需要任何内容
</script>

<template>
  <div class="app-footer">
    <!-- 移除所有底部链接和版权信息 -->
  </div>
</template>

<style scoped lang="scss">
.app-footer {
  text-align: center;
  padding: 2px 0;
}
</style>
